module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Suset2-f8e512986e2245df88cfb01fde2e228a.svg";